<style scoped>
    .table-column-1 {
        width: 40%;
    }
</style>

<template>
    <data-table
        table-id="connection-requests-table"
        table-label="Invited to Connect"
        :items="tableData"
        :fields="fields"
        empty-text="You don't have any pending invitations to connect"
        :show-search-input="true"
        :show-items-per-page-select="true"
    >
        <template #resend-invite="{ item }">
            <button class="btn-orange-blue btn-xs" @click="resendConnectionRequest(item)"><small>Resend</small></button>
        </template>

        <template #disconnect="{ item }">
            <template v-if="!item.declined_at">
                <a class="btn-orange-blue btn-sm" @click="deleteConnectionRequest(item)">Disconnect</a>
                <a class="btn-x" @click="deleteConnectionRequest(item)"><i class="fa fa-times" aria-hidden="true"></i></a>
            </template>
        </template>
    </data-table>
</template>

<script>
    import DataTable from '../../DataTable.vue';

    export default {
        components: {
            DataTable,
        },
        props: {
            sortBy: {
                required: false,
                default: 'user-info',
                type: String
            },
            sortDesc: {
                required: false,
                default: false,
                type: Boolean
            },
            connectionRequests: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'program_name',
                        label: 'User Information',
                        sortable: true,
                        compareFn: 'compareByKey',
                        thStyle: { width: '40%' }
                    },
                    {
                        key: 'created_at',
                        label: 'Date First Invited',
                        sortable: true,
                        compareFn: 'compareDateByKey',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YY'
                        }
                    },
                    {
                        key: 'last_resent_at',
                        label: 'Date of Last Invite',
                        sortable: true,
                        compareFn: 'compareDateByKey',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YY'
                        }
                    },
                    {
                        key: 'declined_at',
                        label: 'Declined At',
                        sortable: true,
                        compareFn: 'compareDateByKey',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YY'
                        }
                    },
                    {
                        key: 'resend-invite',
                        label: 'Resend Invitation',
                    },
                    {
                        key: 'disconnect',
                        label: 'Disconnect',
                        sortable: false
                    }
                ],
                // isLoading: false,
            }
        },
        computed: {
            tableData() {
                return this.connectionRequests.map(item => {
                    item.program_name = item.program.name
                    return item
                })
            },

        },
        methods: {
            updateData() {
                // TODO: just remove the item from the list instead of reloading 
                window.location.reload();
            },
            deleteConnectionRequest(cr) {
                if (confirm('Are you sure you want to delete from this request to connect?')) {
                    axios.delete('api/connection-requests/' + cr.id)
                        .then(response => {
                            this.updateData()
                        })
                        .catch(error => {
                            if (error.response.status == 403) {
                                alert(error.response.data.message)
                            }
                        });
                }
            },
            resendConnectionRequest(cr) {
                axios.get('consultants/resend-connection-request/'+cr.id)
                    .then(response => {
                        this.updateData();
                    });
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            }
        }
    
}
</script>